// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_I-z","twoColumnImage":"aJ-z"};